<template>
  <div
    v-if="isOpen"
    class="vue-popover"
    v-bind:class="{ open: isOpen, [name]: true }"
    :id="id"
    :style="popoverStyle"
    @click.stop="onPopoverContentClick"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <slot></slot>
  </div>
</template>

<script>
  import { getPopoverApi } from '@/plugins/popover-manager';

  export default {
    props: {
      name: {
        type: String,
        required: true
      },
      event: {
        type: String,
        default: 'click'
      },
      width: {
        type: [String, Number],
        default: null
      },
      slim: {
        type: Boolean,
        default: false
      },
      closeOnContentClick: {
        default: true,
        type: Boolean,
        required: false
      }
    },
    data () {
      return {
        popoverApi: getPopoverApi()
      };
    },
    computed: {
      isOpen () {
        return this.popoverApi.isVisible(this.name);
      },
      id () {
        return `popover-${this.name}`;
      },
      popoverStyle () {
        if (this.width === null || this.width === undefined) {
          return null;
        }
        return {
          width: typeof this.width === 'number' ? `${this.width}px` : this.width
        };
      }
    },
    methods: {
      onPopoverContentClick (e) {
        if (e && e.stopPropagation) {
          e.stopPropagation();
        }
        if (this.closeOnContentClick) {
          this.popoverApi.hide(this.name, true);
        }
      },
      handleMouseEnter () {
        if (this.event === 'hover') {
          this.popoverApi.keepOpen(this.name);
        }
      },
      handleMouseLeave () {
        if (this.event === 'hover') {
          this.popoverApi.hide(this.name);
        }
      }
    }
  };
</script>

<style>
  /* Popover section */
  .default .vue-popover ul,
  .custom-face .vue-popover ul {
    margin: 0;
    padding: 5px 0;
    list-style: none;
    background: white;
    -webkit-box-shadow: 0 2px 11px -1px rgba(0, 0, 0, 0.51);
    -moz-box-shadow: 0 2px 11px -1px rgba(0, 0, 0, 0.51);
    box-shadow: 0 2px 11px -1px rgba(0, 0, 0, 0.51);
  }
  .default .vue-popover a,
  .custom-face .vue-popover a {
    display: block;
    text-decoration: none;
    padding: 8px 10px;
    color: black;
    transition: background 0.3s ease;
  }
  .default .vue-popover a:hover,
  .custom-face .vue-popover a:hover {
    color: #141719;
    background-color: #edf1f2;
  }

  .vue-popover {
    position: relative;
    background-color: transparent;
    border: transparent;
  }
  .vue-popover.open {
    position: absolute;
    z-index: 1070;
    right: 0;
    min-width: 160px;
    padding: 5px 0;
    margin: 2px 0 0;
  }

  .popover-item-icon {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
  }

  .popover-item-label {
    margin-left: 5px;
  }
</style>
